import { Icon, IconButton, Tooltip } from "@tm/components"
import { useCallback, useState } from "react"
import { useLocalization } from "@tm/localization"
import { ArticleInfoType } from "@tm/models"
import { BasketPart, BasicBasketPartInfo } from "../../../../../models"
import { PartEditDialog } from "./PartEdit/PartEditDialog"
import { CustomPartEditDialog } from "./PartEdit/CustomPartEditDialog"

type Props = {
    part: BasketPart
    currencyCode: string
    hidePurchasePrice: boolean
    showManufacturer: boolean
    showSupplierArticleNumbers: boolean
    showWholesalerArticleNumbers: boolean
    disableControls?: boolean
    isLinkedItem?: boolean
    creatingCostEstimation: boolean
    onEditPart?(part: BasketPart, editBasketPartInfo: BasicBasketPartInfo): void
}

export function PartEditButton(props: Props) {
    const {
        part,
        hidePurchasePrice,
        onEditPart,
        currencyCode,
        showManufacturer,
        showSupplierArticleNumbers,
        showWholesalerArticleNumbers,
        disableControls,
        isLinkedItem,
        creatingCostEstimation,
    } = props
    const { translateText } = useLocalization()
    const { costEstimationItem, articleInformation } = part.partItem
    const disabled = !costEstimationItem?.isIncluded || disableControls || isLinkedItem || creatingCostEstimation

    const [showEditDialog, setShowEditDialog] = useState<boolean>(false)

    const handleCloseDialog = useCallback(() => {
        setShowEditDialog(false)
    }, [])

    return (
        <>
            <Tooltip title={translateText(122)}>
                <IconButton onClick={() => setShowEditDialog(true)} disabled={disabled}>
                    <Icon name="edit_change" />
                </IconButton>
            </Tooltip>
            {showEditDialog && articleInformation.articleInfoType !== ArticleInfoType.CustomArticle && (
                <PartEditDialog
                    currencyCode={currencyCode}
                    part={part}
                    hidePurchasePrice={hidePurchasePrice}
                    showManufacturer={showManufacturer}
                    showSupplierArticleNumbers={showSupplierArticleNumbers}
                    showWholesalerArticleNumbers={showWholesalerArticleNumbers}
                    disableHeaderButtons={disableControls}
                    onEditPart={onEditPart}
                    onCloseButtonClick={handleCloseDialog}
                />
            )}
            {showEditDialog && articleInformation.articleInfoType === ArticleInfoType.CustomArticle && (
                <CustomPartEditDialog
                    disableHeaderButtons={disableControls}
                    customPartInfo={{
                        part,
                        type: "edit",
                    }}
                    currencyCode={currencyCode}
                    onCloseButtonClick={handleCloseDialog}
                    onEditPart={onEditPart}
                />
            )}
        </>
    )
}
